import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-hui",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-hui.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-hui.component.less",
})
export class PrefixHuiComponent extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 12;
    this.characters = ALLOWED_CHARACTERS["hui"];
  }
}
